// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    0,
    {
      "sub": "房屋管理与维修",
      "tec": "穆林林",
      "week": "1-16周",
      "add": "教学楼D座323文法"
    },
    0,
    {
      "sub": "科技文献检索",
      "tec": "李宏宇",
      "week": "1-4周",
      "add": "教学楼A座221电力"
    },
    0
  ],
  "2": [
    {
      "sub": "物业设施设备维护与管理",
      "tec": "马云俊",
      "week": "1-16周",
      "add": "教学楼D座323文法"
    },
    [
      {
        "sub": "大学英语（三）",
        "tec": "金品卓",
        "week": "1-14周",
        "add": "实训楼E座310"
      },
      {
        "sub": "25经管法1-6",
        "tec": "边克攀",
        "week": "1-14周",
        "add": "实训楼E座403语音室"
      },
      {
        "sub": "25经管法1-3",
        "tec": "马丹",
        "week": "1-14周",
        "add": "实训楼E座401管理"
      },
      {
        "sub": "25经管法1-2",
        "tec": "宋大明",
        "week": "1-14周",
        "add": "教学楼D座320经管"
      },
      {
        "sub": "25经管法2-2",
        "tec": "张琳琳",
        "week": "1-14周",
        "add": "教学楼D座315文法"
      },
      {
        "sub": "25经管法1-4",
        "tec": "吕双双",
        "week": "1-14周",
        "add": "教学楼D座226经管"
      },
      {
        "sub": "25经管法2-1",
        "tec": "杨欣瑶",
        "week": "1-14周",
        "add": "教学楼D座221经管"
      },
      {
        "sub": "25经管法1-1",
        "tec": "贺静",
        "week": "1-14周",
        "add": "教学楼D座125经管"
      },
      {
        "sub": "25经管法1-5",
        "tec": "刘妍",
        "week": "1-14周",
        "add": "教学楼B座319能动"
      }
    ],
    {
      "sub": "就业创业指导",
      "tec": "王星月",
      "week": "1-5周",
      "add": "教学楼D座315文法"
    },
    0,
    0
  ],
  "3": [
    {
      "sub": "中国近现代史纲要",
      "tec": "夏彬",
      "week": "1-12周",
      "add": "教学楼A座122信息"
    },
    {
      "sub": "经济学",
      "tec": "田旭",
      "week": "1-16周",
      "add": "教学楼D座323文法"
    },
    0,
    0,
    0
  ],
  "4": [
    {
      "sub": "科技应用文写作与沟通艺术",
      "tec": "于丹丹",
      "week": "1-16周",
      "add": "教学楼C座213教务"
    },
    [
      {
        "sub": "物业设施设备维护与管理",
        "tec": "马云俊",
        "week": "1,3,5,7,9,11,13,15周",
        "add": "教学楼D座323文法"
      },
      {
        "sub": "房屋管理与维修",
        "tec": "穆林林",
        "week": "2,4,6,8,10,12,14,16周",
        "add": "教学楼D座323文法"
      }
    ],
    [
      {
        "sub": "体育（三）",
        "tec": "李罡",
        "week": "1-18周",
        "add": "足球"
      },
      {
        "sub": "足球",
        "tec": "陈迪",
        "week": "1-18周",
        "add": "足球"
      },
      {
        "sub": "女乒",
        "tec": "李欣诺",
        "week": "1-18周",
        "add": "足球"
      },
      {
        "sub": "女网",
        "tec": "张慧",
        "week": "1-18周",
        "add": "足球"
      },
      {
        "sub": "女篮",
        "tec": "王文娇",
        "week": "1-18周",
        "add": "足球"
      },
      {
        "sub": "健美操",
        "tec": "郝俊",
        "week": "1-18周",
        "add": "足球"
      },
      {
        "sub": "女排",
        "tec": "郭芯源",
        "week": "1-18周",
        "add": "足球"
      },
      {
        "sub": "男篮",
        "tec": "贾思敏",
        "week": "1-18周",
        "add": "足球"
      },
      {
        "sub": "男篮",
        "tec": "刘玉坤",
        "week": "1-18周",
        "add": "足球"
      },
      {
        "sub": "搏击",
        "tec": "李庆",
        "week": "1-18周",
        "add": "足球"
      },
      {
        "sub": "轮滑",
        "tec": "郝策",
        "week": "1-18周",
        "add": "足球"
      },
      {
        "sub": "男网",
        "tec": "李灏",
        "week": "1-18周",
        "add": "足球"
      },
      {
        "sub": "男乒",
        "tec": "李莉",
        "week": "1-18周",
        "add": "足球"
      },
      {
        "sub": "女羽",
        "tec": "任德鑫",
        "week": "1-18周",
        "add": "足球"
      }
    ],
    0,
    {
      "sub": "形势与政策",
      "tec": "杨淑一",
      "week": "1-4周",
      "add": "教学楼C座306教务"
    }
  ],
  "5": [
    0,
    {
      "sub": "中国近现代史纲要",
      "tec": "夏彬",
      "week": "1-12周",
      "add": "教学楼A座127信息"
    },
    [
      {
        "sub": "大学英语（三）",
        "tec": "刘妍",
        "week": "1-14周",
        "add": "实训楼E座412语音室"
      },
      {
        "sub": "25经管法1-7",
        "tec": "宋大明",
        "week": "1-14周",
        "add": "实训楼E座406语音室"
      },
      {
        "sub": "25经管法2-2",
        "tec": "张琳琳",
        "week": "1-14周",
        "add": "实训楼E座403语音室"
      },
      {
        "sub": "25经管法1-4",
        "tec": "吕双双",
        "week": "1-14周",
        "add": "实训楼E座414管理"
      },
      {
        "sub": "25经管法2-1",
        "tec": "杨欣瑶",
        "week": "1-14周",
        "add": "实训楼E座401管理"
      },
      {
        "sub": "25经管法1-1",
        "tec": "金品卓",
        "week": "1-14周",
        "add": "教学楼D座224经管"
      },
      {
        "sub": "25经管法1-6",
        "tec": "马丹",
        "week": "1-14周",
        "add": "教学楼D座221经管"
      },
      {
        "sub": "25经管法1-2",
        "tec": "边克攀",
        "week": "1-14周",
        "add": "教学楼D座213经管"
      },
      {
        "sub": "25经管法1-3",
        "tec": "贺静",
        "week": "1-14周",
        "add": "实训楼E座310"
      }
    ],
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
